import { render, staticRenderFns } from "./Submissions.vue?vue&type=template&id=134d026f&scoped=true"
import script from "./Submissions.vue?vue&type=script&lang=js"
export * from "./Submissions.vue?vue&type=script&lang=js"
import style0 from "./Submissions.vue?vue&type=style&index=0&id=134d026f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134d026f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('134d026f')) {
      api.createRecord('134d026f', component.options)
    } else {
      api.reload('134d026f', component.options)
    }
    module.hot.accept("./Submissions.vue?vue&type=template&id=134d026f&scoped=true", function () {
      api.rerender('134d026f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/dashboard/components/Submissions.vue"
export default component.exports